import { useEffect } from "react"

import { Text } from "@chakra-ui/react"
import { useLocation } from "react-router-dom"

import { Endpoints } from "types"

const mappingToTitle = {
  [Endpoints.manageUsers]: "Manage Admin Users",
  [Endpoints.propertyDashboard]: "Property Dashboard",
  [Endpoints.userDashboard]: "User Dashboard",
  [Endpoints.emailCommunication]: "Email Communications",
  [Endpoints.bookingDashboard]: "Old Booking Dashboard",
  [Endpoints.newBookingDashboard]: "Booking Dashboard",
  [Endpoints.hcfChargeDashboard]: "HCF Charge Dashboard",
  [Endpoints.companyDashboard]: "Company Dashboard",
  [Endpoints.manageCompanyDiscount]: "Company Discount",
  [Endpoints.managePropertyDiscount]: "Property Discount",
  [Endpoints.hostPayoutDashboard]: "Host Payout Dashboard",
  [Endpoints.faq]: "FAQ",
  [Endpoints.reports]: "Reports",
  [Endpoints.manageRole]: "Manage Role",
  [Endpoints.systemEmailLog]: "System Email Logs",
  [Endpoints.manageTokens]: "Manage Tokens",
  [Endpoints.onboarding]: "Onboarding",
  [Endpoints.events]: "Events",
  [Endpoints.pmsFeesManage]: "PMS Fees Manage",
  [Endpoints.managePromoCodes]: "Manage Promo Codes",
  [Endpoints.redeemPromoCodes]: "Redeemed Promo Codes",
  [Endpoints.sendEmails]: "Send Emails",
  [Endpoints.reviewManagement]: "Review Management",
  [Endpoints.feeMapping]: "Fee Mapping",
  [Endpoints.callerVerification]: "Caller Verification",
  [Endpoints.heroBanner]: "Hero Banner",
  [Endpoints.propertyManagement]: "Featured Property",
  [Endpoints.newToWhimstay]: "New to Whimstay",
  [Endpoints.regionalLanding]: "Regional Landing",
  [Endpoints.bcomBookingDashboard]: "Bcom Booking Dashboard",
  [Endpoints.globalRulesManagement]: "Global Rules Management",
  [Endpoints.hostRulesManagement]: "Host Rules Management",
  [Endpoints.travelAgentDashboard]: "Agent Management",
  [Endpoints.commissionDashboard]: "Commission Management",
  [Endpoints.agentPayoutDashboard]: "Agent Payout Accounts",
}

export const getTitleForUrl = (url: string): string | undefined => {
  const urlTitleMap: { [key: string]: string } = {
    "bookingDashboard/details": "Old Booking Dashboard",
    "bookingDashboard/invoice": "Old Booking Dashboard",
    "newBookingDashboard/details": "Booking Dashboard",
    "newBookingDashboard/invoice": "Booking Dashboard",
    "bcomBooking/details": "Bcom Booking Dashboard",
    "emailCommunication/details": "Email Communications",
    "systemEmailLog/details": "System Email Logs",
    "emailCommunication/details/:id/forward": "Email Communications",
  }

  for (const pattern in urlTitleMap) {
    const regexPattern = "^" + pattern.replace(/:[^/]+/g, "[^/]+") + "$"
    const regex = new RegExp(regexPattern)
    if (regex.test(url)) {
      return urlTitleMap[pattern]
    }
  }

  return undefined
}

const Title = () => {
  const location = useLocation()
  const getUrl = location.pathname.split("/")
  const newUrl = getUrl[1] + "/" + getUrl[2]

  useEffect(() => {
    document.title =
      mappingToTitle[location.pathname as keyof typeof mappingToTitle] ||
      "Whimstay Admin Portal"
  }, [location.pathname])

  const title = mappingToTitle[location.pathname as keyof typeof mappingToTitle]
  const titles = getTitleForUrl(newUrl) || title
  return (
    <Text
      size={{ base: "md", sm: "lg", lg: "lg2" }}
      fontWeight={600}
      color='black.1000'
      mr={2}
    >
      {titles || "Whimstay Admin Portal"}
    </Text>
  )
}

export default Title
